import MentionsOfficialAccountCommentList from './MentionsOfficialAccountCommentList';

export default MentionsOfficialAccountCommentList;
